import {
  Box,
  Container,
  Fade,
  Stack,
  Typography,
} from '@mui/material'

import { HERO } from './content'

const maskGradient = {
  xs: 'linear-gradient(to bottom, black 0%, black 35%, transparent 90%)',
  md: 'linear-gradient(to right, transparent 0%, black 70%)',
}

const backgroundStyles = {
  backgroundImage: 'url(/games/grimtile/banner-b.png)',
  backgroundPosition: { xs: '65% top', md: 'center right' },
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: { xs: '58vh', md: '75vh' },
  left: { xs: 0, md: 'auto' },
  maskImage: maskGradient,
  position: 'absolute',
  right: 0,
  top: 0,
  WebkitMaskImage: maskGradient,
  width: { xs: '100%', md: '60%' },
}

const sectionStyles = {
  backgroundColor: '#000000',
  minHeight: { md: '80vh' },
  overflow: 'hidden',
  pb: { xs: 6, md: 12 },
  position: 'relative',
  pt: { xs: '47vh', md: 16 },
  userSelect: 'none',
}

const monoFont = '"JetBrains Mono", monospace'
const serifFont = '"Cormorant Garamond", serif'

const storeBadgeSx = {
  display: 'inline-block',
  lineHeight: 0,
}

const BADGE_HEIGHT = { xs: 48, md: 56 }

const Hero = () => (
  <Box component="section" id="main" sx={sectionStyles}>
    <Box sx={backgroundStyles} />

    <Container maxWidth="lg" sx={{ position: 'relative' }}>
      <Fade in timeout={1000}>
        <Stack
          alignItems={{ xs: 'center', md: 'flex-start' }}
          spacing={2}
          sx={{ maxWidth: { md: 460 }, pt: { md: 10 }, textAlign: { xs: 'center', md: 'left' } }}
        >
          <Typography
            sx={{
              color: 'warning.light',
              fontFamily: monoFont,
              fontSize: 13,
              fontWeight: 500,
              letterSpacing: 3,
              textTransform: 'uppercase',
            }}
          >
            {HERO.EYEBROW}
          </Typography>

          <Typography
            sx={{
              color: 'grey.100',
              fontFamily: serifFont,
              fontSize: { xs: 56, md: 80 },
              fontWeight: 600,
              lineHeight: 1,
            }}
          >
            {HERO.TITLE}
          </Typography>

          <Typography
            sx={{
              color: 'warning.light',
              fontFamily: serifFont,
              fontSize: { xs: 26, md: 34 },
              fontStyle: 'italic',
              fontWeight: 500,
            }}
          >
            {HERO.TAGLINE}
          </Typography>

          <Box>
            {HERO.DESCRIPTION.map((line) => (
              <Typography
                key={line}
                sx={{
                  color: 'grey.500',
                  fontFamily: monoFont,
                  fontSize: { xs: 14, md: 15 },
                  lineHeight: 1.8,
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>

          <Stack
            direction="row"
            spacing={2}
            sx={{ pt: 2 }}
          >
            <Box
              component="a"
              href={HERO.IOS_APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={storeBadgeSx}
            >
              <Box
                component="img"
                src={HERO.IOS_BADGE_IMAGE_URL}
                alt="Download on the App Store"
                sx={{ height: BADGE_HEIGHT, width: 'auto' }}
              />
            </Box>

            <Box
              component="a"
              href={HERO.ANDROID_PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={storeBadgeSx}
            >
              <Box
                component="img"
                src={HERO.ANDROID_BADGE_IMAGE_URL}
                alt="Get it on Google Play"
                sx={{ height: BADGE_HEIGHT, width: 'auto' }}
              />
            </Box>
          </Stack>
        </Stack>
      </Fade>
    </Container>
  </Box>
)

export default Hero
